define("shared/components/shared/ui/social-profile-switcher/item", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li class="o--dropBody__item qa--profileSwitcher_social_set_option" ...attributes>
    {{#if @onChange}}
      <a class="o--dropBody__link" {{on "click" (fn @onChange @socialProfile undefined)}}>
        <Shared::ProfileAvatar @showDetails={{true}} @showPlatform={{true}} @socialProfile={{@socialProfile}} />
      </a>
    {{else}}
      <a class="o--dropBody__link">
        <Shared::ProfileAvatar @showDetails={{true}} @showPlatform={{true}} @socialProfile={{@socialProfile}} />
      </a>
    {{/if}}
  </li>
  */
  {
    "id": "t1JRU+i0",
    "block": "[[[11,\"li\"],[24,0,\"o--dropBody__item qa--profileSwitcher_social_set_option\"],[17,1],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[11,3],[24,0,\"o--dropBody__link\"],[4,[38,1],[\"click\",[28,[37,2],[[30,2],[30,3],[27]],null]],null],[12],[1,\"\\n      \"],[8,[39,3],null,[[\"@showDetails\",\"@showPlatform\",\"@socialProfile\"],[true,true,[30,3]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,3],[14,0,\"o--dropBody__link\"],[12],[1,\"\\n      \"],[8,[39,3],null,[[\"@showDetails\",\"@showPlatform\",\"@socialProfile\"],[true,true,[30,3]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"&attrs\",\"@onChange\",\"@socialProfile\"],false,[\"if\",\"on\",\"fn\",\"shared/profile-avatar\"]]",
    "moduleName": "shared/components/shared/ui/social-profile-switcher/item.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});